import { ALL_MEMBERS } from '../ids';
export const ids = ALL_MEMBERS;
export const getDefinition = () => ({
    method: 'addApplicationToSite',
    social: true,
    ...ALL_MEMBERS,
});
//# sourceMappingURL=all-members.js.map